'use strict';

import uuid from 'uuid';

/**
 * @property {String}         id          - unique id of campaign setting
 * @property {String}         name        - unique name of campaign setting
 * @property {Array<String>}  lore        - array of lore ids that pertain to the campaign
 * @property {Array<String>}  users       - array of user ids who are members or participants in the setting
 * @property {Array<String>}  invited     - array of user ids who are invited to join the setting
 * @property {Boolean}        inviteOnly  - is the campaign invitation only?
 * @property {String}         theme       - the name of the theme to use for styling
 * @property {Date}           created     - timestamp of content block creation
 * @property {Date}           modified    - timestamp of content block update
 */
export default class CampaignSetting {
  /**
   * @param {String}        id
   * @param {String}        name
   * @param {Array<String>} lore
   * @param {Array<String>} users
   * @param {Array<String>} invited
   * @param {Boolean}       inviteOnly
   * @param {String}        theme
   * @param {Date}          created
   * @param {Date}          modified
   */
  constructor(id, name, lore, users, invited, inviteOnly, theme, created, modified) {
    this.id = id || uuid.v4();
    this.name = name || null;
    this.lore = lore || [];
    this.users = users || [];
    this.invited = invited || [];
    this.inviteOnly = inviteOnly || false;
    this.theme = theme || 'default';
    // @TODO:  Add support for custom CSS?
    this.created = created || new Date();
    this.modified = modified || new Date();
  }
}